<template>
  <div class="page digital-marketing-assets">    
    <PageFull noOverlay fullWidth>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">              
                <div class="image"><img src="@/assets/images/bg_shape.jpg" alt=""></div>                          
                  <div class="page-content content">                    
                    <transition name="slide-fade" mode="out-in" appear>
                      <TitleContent h2="Marketing" h1="Digital Marketing Assets" />                    
                    </transition>
                    <transition name="slide-fade" mode="out-in" appear>
                      <div class="text-content">
                          <div class="row">
                              <img src="@/assets/images/marketing/digital_marketing_assets/icon_white_people.svg" alt="">
                              <p>Access to Season Ticket Holders</p>
                              <div class="right">
                                <p>54,675 and 36,000 on waitlist</p>
                              </div>
                          </div>
                          <div class="row">
                              <img src="@/assets/images/marketing/digital_marketing_assets/icon_white_phone.svg" alt="">
                              <p>Mobile App Notifications</p>
                              <div class="right">
                                    <img src="@/assets/logo/logo_secondary.svg" alt="">
                                    <img src="@/assets/icons/icon_plus-sign.svg" alt="" class='plus'>
                                    <img src="@/assets/logo/logo_raiders.svg" alt="">
                                    <span class="divider"/>                          
                                    <img src="@/assets/images/marketing/digital_marketing_assets/icon_app.png" alt="">          
                              </div>
                          </div>
                          <div class="row">
                              <img src="@/assets/images/marketing/digital_marketing_assets/icon_white_social.svg" alt="">
                              <p>Social Media Support</p>
                              <div class="right">
                                <img src="@/assets/logo/logo_secondary.svg" alt="">
                                <span class="social-media"><img src="@/assets/logo/icon_facebook.svg" alt=""></span>
                                <span class="social-media"><img src="@/assets/logo/icon_instagram.svg" alt=""></span>
                                <span class="social-media"><img src="@/assets/logo/icon_twitter.svg" alt=""></span>
                                <span class="divider"/>
                                <img src="@/assets/logo/logo_raiders.svg" alt="">
                                <span class="social-media"><img src="@/assets/logo/icon_facebook.svg" alt=""></span>
                                <span class="social-media"><img src="@/assets/logo/icon_instagram.svg" alt=""></span>
                                <span class="social-media"><img src="@/assets/logo/icon_twitter.svg" alt=""></span>
                              </div>
                          </div>
                          <div class="row">
                              <img src="@/assets/images/marketing/digital_marketing_assets/icon_white_computer.svg" alt="">
                              <p>Website Support</p>
                              <div class="right">
                                  <a target="_blank" href="https://allegiantstadium.com">AllegiantStadium.com</a>
                                  <a target="_blank" href="https://raiders.com">Raiders.com</a>
                              </div>
                          </div>
                          <div class="row">
                              <img src="@/assets/images/marketing/digital_marketing_assets/icon_white_newsletter.svg" alt="">
                              <p>Newsletter Inclusion</p>
                          </div>
                      </div>
                    </transition>
                  </div>                
            </div>
        </div>
    </template>
    </PageFull>        
  </div>
</template>

<script>
import TitleContent from "@/patterns/TitleContent.vue";
import PageFull from "@/patterns/PageFull.vue";
export default {
  name: "MarketingEnd",
  components: { TitleContent, PageFull }  
};
</script>
<style lang="scss">
  .digital-marketing-assets {
    .right img.plus {
      height:9px;      
    }
    .social-media {
      width:45px;
      height:45px;
      background:rgba(#fff, 0.1);
      border-radius: 100%;
      display:inline-block;      
      box-sizing: border-box;
      &:not(:last-child) {
        margin-right:10px;
      }
      img {        
        width:inherit;
        height:inherit;
        transform:scale(0.5);
        object-position: contain;
      }
    }
    .divider {
      display:inline-block;
      height: 53px;
      width: 1px;
      background-color: #4B4B4D;
      margin:0 20px;
    }
    .right img {
      height:45px;
    }
    .row {
      display:flex;
      padding:10px 25px;
      min-height:75px;
      box-sizing: border-box;
      border-radius: 10px;
      background: linear-gradient(135deg, #313131 0%, #141414 100%);
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.2);
      align-items:center;      
      flex-wrap: wrap;
      p {
        margin:0;
      }
      &:not(:last-child) {
        margin-bottom: 10px;
      }
      > img {
        margin-right:25px;
      }
      > * {
        flex-grow: 0;
        flex-shrink: 0; 
        display:inline-block;      
      }
    }
    .right {
      flex-grow: 1;
      flex-shrink: 0;
      text-align: right;      
      > * {
        vertical-align: middle;
      }
      > img {
        margin-right:20px;
      }
    }
    a {
      border-radius: 3px;
      background-color: rgba(#FFFFFF, 0.1);
      padding:8px 10px;
      color: #FFFFFF;
      font-family: 'Gotham';
      font-size: 0.75em;
      font-weight: 900;
      letter-spacing: 0;
      line-height: 16px;
      text-decoration: none;
      &:not(:last-child) {
        margin-right:10px;
      }
    }
  }
</style>
